<template>
  <pt-branch-company class="pt-branch-company__withData" @deleteBranchCompany="deleteBranchCompany" ref="table"></pt-branch-company>
</template>

<script>
import PtBranchCompany from './index'
export default {
  name: 'pt-branch-company__withData',
  components: {
    'pt-branch-company': PtBranchCompany
  },
  methods: {
    deleteBranchCompany (id) {
      this.$store.dispatch('deleteBranchCompany', id).then(res => {
        this.$message.success('删除分/子公司成功')
        this.$refs.table.getTableData()
      }).catch(err => {
        this.$message.error(err || '删除分/子公司失败')
      })
    }
  }
}
</script>
